import { Table } from '@maia/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useAttachmentTable } from '../../../../features/shared/attachments/attachments-table';
import { getInsuranceDocuments } from '../../../../features/insurance/documents/queryOptionts';

export const Route = createFileRoute(
  '/_authenticated/insurances/$guid/_layout/documents',
)({
  component: Page,
  loader: ({ context: { queryClient }, params }) =>
    queryClient.ensureQueryData(
      getInsuranceDocuments({ insuranceGuid: params.guid }),
    ),
});

function Page() {
  const data = Route.useLoaderData();

  const table = useAttachmentTable(
    data.documents.map((item) => ({
      guid: item.guid,
      name: item.name ?? '',
      reason: item.reason ?? undefined,
      children:
        item.history?.map((history) => ({
          ...history,
          reason: history.reason ?? undefined,
        })) ?? undefined,
    })),
  );

  return (
    <div className="col-span-full flex items-center justify-between">
      <Table table={table} className="grid-cols-[auto_min-content]" />
    </div>
  );
}
